export default class SimpleNotificationDialog {
    #id;
    constructor(id = 'simple-notification-dialog') {
        this.#id = id;
        this._dialog = null;
        this._onOk = () => {
        };
    }

    /**
     * @param {string} html
     * @param {string} cssClassName
     * @returns {SimpleNotificationDialog}
     */
    render(html, cssClassName) {
        const dialogEl = this.#getDialogEl();
        dialogEl.classList.add(cssClassName);
        dialogEl.innerHTML = SimpleNotificationDialog._htmlTemplate(html);

        const okBtn = this._dialog.querySelector('.btn-ok');
        okBtn.addEventListener('click', () => {
            this._onOk();
            this.remove();
        })
        this._dialog.addEventListener('keydown', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            if (evt.repeat) return;
            switch (evt.key) {
                case 'Enter' :
                case 'Escape' :
                    okBtn.dispatchEvent(new Event('click'))
            }
        });
        dialogEl.showModal();
    }

    onOk(cb){
        this._onOk = cb;
    }

    remove() {
        this._dialog.remove();
        this._dialog = null;
    }

    isAlreadyShown() {
        return !!document.getElementById(this.#id);
    }

    #getDialogEl() {
        if (!this._dialog) {
            const dialog = document.body
                .insertAdjacentElement("beforeend", document.createElement('dialog'));
            dialog.setAttribute("id", this.#id);
            this._dialog = dialog;
        }
        return this._dialog;
    }

    /**
     * @param {string} html
     * @returns {string}
     * @private
     */
    static _htmlTemplate(html) {
        return `
            <div class="dialog-content">
                ${html}
            </div>
            <div class="dialog-buttons-row">
                <button class="button button--contained btn-ok btn-cancel">Ok</button>
            </div>`;
    }
}